import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const Card = ({ children, className, pSmall = false }) => {
  return (
    <div className={twMerge(
      "bg-white rounded-xl shadow-sm border border-slate-200",
      pSmall ? "p-4" : "p-6",
      className
    )}>
      {children}
    </div>
  );
};